import React from 'react';
import styles from './index.module.scss';
import TitleComponent from '../../text_components/title_component';
import UnknownText from '../../text_components/unknown_text';
import DescriptionComponent from '../../long_text_components/description_component';
import UnknownLongText from '../../long_text_components/unknown_long_text';
import MainImgComponent from '../../img_components/main_img_component';
import UnknownImg from '../../img_components/unknown_img';
import GalleryComponent from '../../imgs_block_components/gallery_component';
import UnknownImgsBlock from '../../imgs_block_components/unknown_imgs_block';
import VideoComponent from '../../video_components/video_component';
import UnknownVideo from '../../video_components/unknown_video';

const BlockB = ({ blockData, path_to_folder }) => {
  const renderContent = (content) => {
    if (content.cotent_type === 'text' || content.content_type === 'text') {
      switch (content.cotent_tag || content.content_tag) {
        case 'title':
          return (
            <TitleComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownText
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }
    if (content.cotent_type === 'long_text' || content.content_type === 'long_text') {
      switch (content.cotent_tag || content.content_tag) {
        case 'description':
          return (
            <DescriptionComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownLongText
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }
    if (content.cotent_type === 'img' || content.content_type === 'img') {
      switch (content.cotent_tag || content.content_tag) {
        case 'main_img':
          return (
            <MainImgComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownImg
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }
    if (content.cotent_type === 'imgs_block' || content.content_type === 'imgs_block') {
      switch (content.cotent_tag || content.content_tag) {
        case 'gallery':
          return (
            <GalleryComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownImgsBlock
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }
    if (content.cotent_type === 'video' || content.content_type === 'video') {
      switch (content.cotent_tag || content.content_tag) {
        case 'video':
          return (
            <VideoComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownVideo
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }
    return null;
  };

  return (
    <div className={styles.blockB}>
      <h2 className={styles.title}>Блок B</h2>
      <p className={styles.description}>Компонент блока B</p>
      {blockData && blockData.block_content && Array.isArray(blockData.block_content) && (
        <div className={styles.contentContainer}>
          <h4>Контент блока:</h4>
          {blockData.block_content.map((content, index) => (
            <div key={index} className={styles.contentWrapper}>
              {renderContent(content)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlockB;
